// extracted by mini-css-extract-plugin
module.exports = {"narrative-wrapper":"narrative-slider_narrative-wrapper__Kn6Qz","narrative-header":"narrative-slider_narrative-header__T1HEf"};